<template>
  <div class="page-container"  >
    <footer class=" py-3">
        <div class="row row-cols-1 g-4 pe-1 mx-2 mt-1" style="margin: 2%!important; margin-top: 0!important;"  >
          <div class="col-md-3 col-sm-3 " >
            <h5 class="mb-3 text-white text-start">Основная информация</h5>
            <ul class="list-unstyled text-muted" style="text-align: left">
              <li ><a  class="text-white" href="/catalog">Каталог</a></li>
              <li class="spacing-text"><a class="text-white" href="/recipes">Рецепты</a></li>
              <li class="spacing-text"><a class="text-white" href="#">Доставка</a></li>
              <li class="spacing-text"><a class="text-white" href="#">Оплата</a></li>
              <li class="spacing-text"><a class="text-white" href="#">О нас</a></li>
              <li class="spacing-text"><a class="text-white" href="#">Профиль</a></li>
            </ul>
          </div>
          <div class="col-md-3 col-sm-3 " >
            <h5 class="text-white mb-3 text-start">Дополнительная информация</h5>
            <ul class="list-unstyled text-muted" style="text-align: left" >
              <li ><a class="text-white" href="/offerAndPrivacyPolicy">Оферта и политика конфиденциальности</a></li>
              <li class="spacing-text"><a  class="text-white" href="/userAgreement">Пользовательское соглашение</a></li>
              <li class="spacing-text"><a class="text-white" href="/termsOfExchangeAndRefund">Условия обмена и возврата</a></li>
              <li class="spacing-text"><a class="text-white" href="/personal_data_policy">Политика обработки персональных данных</a></li>
              <li class="spacing-text"><a class="text-white" href="/publicOfferAgreementForLeAndIe">Оферта для юр. лиц и ИП</a></li>
              <li class="spacing-text"><a class="text-white" href="#">Обратная связь</a></li>
            </ul>
          </div>
          <div class="col-md-3 col-sm-3 offset-md-2 offset-lg-2 offset-xl-3 w-auto  " >
            <h5 class="text-white mb-3 text-start">Контакты</h5>
            <ul class="list-unstyled text-muted " style="text-align: left">
              <li><h6 href="#" class="text-white" >Служба поддержки</h6></li>
              <li class="spacing-text">
                <a href="tel:+78612047010" class="mb-3 text-white">
                  +7 (861) 204-70-10
                </a>
              </li>
              <li class="spacing-text"><h6 href="#" class="text-white" >Мы в соц. сетях</h6></li>
              <li class="spacing-text" > <a href="https://vk.com/addgrill"><img class="" src="/assets/logo_vk.svg"> </a> <a class="px-2"></a> <a href="https://www.instagram.com/addgrill?igsh=NTc4MTIwNjQ2YQ=="><img class="" src="/assets/logo_instagram.svg"></a><img style=" margin-top: -2.5em!important;" src="/assets/logo_star.svg"></li>
              <li class="spacing-text"><h6 class="text-white" style="font-size: 0.7rem!important;">* Экстремистская организация в РФ</h6></li>
            </ul>

          </div>
        </div>
      <a class="footer-brand" href="#">
        <img src="/assets/logo_addgrill_with_text.svg" alt="AddGrill">
      </a>
      <p class="small text-muted mb-0 text-white pt-3" style="color: white!important;">&copy; 2021-2024 AddGrill.com — уникальные аксессуары для гриля. Официальный сайт производителя. Любое использование контента без письменного разрешения запрещено.</p>
    </footer>

  </div>
</template>

<style>
.spacing-text{
  margin-top : 0.6rem!important;
}
a {
  color: white;

  text-decoration: none;
  transition: all 0.3s;
}
p{
  color: white;

}

a:hover, a:focus {
  text-decoration: none;
}

.form-control {
  background: #212529;
  border-color: #545454;
}

.form-control:focus {
  background: #212529;
}

footer {
  background: #474747FF;
}
</style>
<style scoped>


</style>